import { isEqual } from 'date-fns'
import React from 'react'
import { WithTranslation } from 'react-i18next'
import { IDayFormat } from './DateFormatter'

function withUpdate(C: React.ComponentType<IDayFormat & WithTranslation>) {
  return class EventsWithUpdate extends React.Component<
    IDayFormat & WithTranslation
  > {
    public shouldComponentUpdate = (
      nextProps: IDayFormat & WithTranslation,
    ) => {
      return (
        !isEqual(this.props.date, nextProps.date) ||
        this.props.dateFormat !== nextProps.dateFormat ||
        this.props.style !== nextProps.style
      )
    }

    public render = () => <C {...this.props} />
  }
}

export default withUpdate
